/**
 * Site languages. Spanish is the default and lives at unprefixed URLs; English under /en and
 * Brazilian Portuguese under /pt. A page only advertises (hreflang, sitemap, language menu) the
 * languages it really exists in: see routes.ts `availableLocales`.
 */
export const locales = ["es", "en", "pt"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "es";

export const isLocale = (value: unknown): value is Locale => (locales as readonly unknown[]).includes(value);
/** Prefixed languages and their URL prefix. */
export const localePrefix: Record<Locale, string> = { es: "", en: "/en", pt: "/pt" };

/** BCP 47 tags for Intl: Colombian Spanish keeps the house number style (1.234,5). */
export const intlLocale: Record<Locale, string> = { es: "es-CO", en: "en-US", pt: "pt-BR" };
/** hreflang / <html lang> values. */
export const htmlLang: Record<Locale, string> = { es: "es", en: "en", pt: "pt-BR" };
/** Open Graph locales (Facebook's list). */
export const ogLocale: Record<Locale, string> = { es: "es_LA", en: "en_US", pt: "pt_BR" };
/** Language names written in their own language, for the switcher. */
export const localeName: Record<Locale, string> = { es: "Español", en: "English", pt: "Português" };
/** Every other language of the site. */
export const otherLocales = (locale: Locale): Locale[] => locales.filter(l => l !== locale);
/** @deprecated two-language helper kept for callers that still pair es/en; prefer otherLocales. */
export const otherLocale = (locale: Locale): Locale => (locale === "es" ? "en" : "es");
